export default __webpack_public_path__ + "static/media/subscribe.3b0b0537.webp";